export default function FundingGoalSection({ onDonateClick }: { onDonateClick: () => void }) {
  return (
    <section id="funding" className="py-32 px-8 bg-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-20 w-64 h-64 bg-amber-600 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-amber-400 rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-5xl mx-auto text-center relative z-10">
        <h2 
          className="text-6xl font-black text-gray-900 leading-tight mb-6"
          style={{ fontFamily: "'Noto Serif KR', serif" }}
        >
          당신의 후원이<br />
          신공을 완성합니다
        </h2>
        
        <p className="text-xl text-gray-600 mb-12">
          목표 금액 <strong className="text-amber-600 text-2xl">50,000,000원</strong> | 제작비의 20% 보충
        </p>
        
        <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-12 mb-12 shadow-2xl">
          <div className="grid grid-cols-3 gap-8 text-white">
            <div className="space-y-3">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-600 rounded-full mx-auto">
                <i className="ri-film-line text-xl"></i>
              </div>
              <h3 className="text-lg font-bold">프리 프로덕션</h3>
              <p className="text-sm text-gray-400">시나리오 완성 및 캐스팅</p>
              <p className="text-amber-400 font-semibold">₩15,000,000</p>
            </div>
            
            <div className="space-y-3">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-600 rounded-full mx-auto">
                <i className="ri-camera-line text-xl"></i>
              </div>
              <h3 className="text-lg font-bold">촬영 및 제작</h3>
              <p className="text-sm text-gray-400">메인 촬영 및 특수효과</p>
              <p className="text-amber-400 font-semibold">₩25,000,000</p>
            </div>
            
            <div className="space-y-3">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-600 rounded-full mx-auto">
                <i className="ri-movie-2-line text-xl"></i>
              </div>
              <h3 className="text-lg font-bold">포스트 프로덕션</h3>
              <p className="text-sm text-gray-400">편집, 음악, 마케팅</p>
              <p className="text-amber-400 font-semibold">₩10,000,000</p>
            </div>
          </div>
        </div>
        
        <button 
          onClick={onDonateClick}
          className="bg-amber-600 text-white px-12 py-5 rounded-full text-lg font-bold hover:bg-amber-700 transition-all shadow-lg hover:shadow-xl flex items-center gap-3 mx-auto whitespace-nowrap cursor-pointer"
        >
          지금 후원하기
          <i className="ri-arrow-right-line text-xl"></i>
        </button>
        
        <div className="mt-16 flex items-center justify-center gap-12 opacity-60">
          <div className="flex items-center gap-3">
            <i className="ri-film-fill text-4xl text-gray-400"></i>
          </div>
          <div className="flex items-center gap-3">
            <i className="ri-clapperboard-fill text-4xl text-gray-400"></i>
          </div>
          <div className="flex items-center gap-3">
            <i className="ri-movie-2-fill text-4xl text-gray-400"></i>
          </div>
          <div className="flex items-center gap-3">
            <i className="ri-award-fill text-4xl text-gray-400"></i>
          </div>
        </div>
      </div>
    </section>
  );
}
